import { useEffect } from 'react';
import { useSoundEngine } from '../../hooks/useSoundEngine';
import './OutcomePanel.css';

/**
 * Outcome panel shown after STOP:
 * Correct (+1), Wrong (-1), Pass (skip word).
 * Also shows the current word and optionally a cancel button.
 */
export const OutcomePanel = ({
  word,
  passesLeft,
  onCorrect,
  onWrong,
  onPass,
  onReport,
  onCancel,
  showPass = true,
  isTimeUp = false,
}) => {
  const sound = useSoundEngine();

  useEffect(() => {
    // Il timer estetico dura 5 secondi (come definito nel CSS)
    const timer = setTimeout(() => {
      sound.playInterruptionEnd();
    }, 5000);

    return () => clearTimeout(timer);
  }, [sound]);

  return (
    <div className="outcome-panel u-slide-up">
      <button
        className="outcome-report-mini"
        onClick={onReport}
        id="btn-report"
        title="Segnala questa parola"
      >
        <span className="outcome-report-mini__icon">⚠️</span>
        <span className="outcome-report-mini__text">SEGNALA</span>
      </button>

      <div className="outcome-panel__header">
        <p className="outcome-panel__label">La parola era</p>
        <h2 className="outcome-panel__word">{word}</h2>
      </div>

      <div className="outcome-panel__buttons">
        <button className="outcome-btn outcome-btn--correct" onClick={onCorrect} id="btn-correct">
          <span className="outcome-btn__icon">✓</span>
          <span className="outcome-btn__text">GIUSTA</span>
          <span className="outcome-btn__sub">+1</span>
        </button>

        <button className="outcome-btn outcome-btn--wrong" onClick={onWrong} id="btn-wrong">
          <span className="outcome-btn__icon">✗</span>
          <span className="outcome-btn__text">SBAGLIATA</span>
          <span className="outcome-btn__sub">-1</span>
        </button>

        {showPass ? (
          <button
            className="outcome-btn outcome-btn--pass"
            onClick={onPass}
            disabled={!isTimeUp && passesLeft <= 0}
            id="btn-pass"
          >
            <span className="outcome-btn__icon">→</span>
            <span className="outcome-btn__text">PASSO</span>
            <span className="outcome-btn__sub">
              {isTimeUp ? 'GRATIS' : `${passesLeft} rimasti`}
            </span>
          </button>
        ) : null}
      </div>

      {/* Aesthetic exhaustion bar (5 seconds) */}
      <div className="outcome-timer">
        <div className="outcome-timer__bar"></div>
      </div>

      {onCancel ? (
        <button className="outcome-panel__cancel" onClick={onCancel}>
          Annulla STOP
        </button>
      ) : null}
    </div>
  );
};
